import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
//import {WebFormContainerComponent} from "../../../../common/components/web.form.container/web.form.container.component";
import {AppConfigurationService} from "../../../../common/app-config/app-configuration.service";
import {WebFormLightContainerComponent} from "../../../../common/components/web.form.light.container/web.form.light.container.component";
import {PreLoginSystemConfigurationValues} from "../../../../common/configuration/services/prelogin.system.configuration.manager";

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient.details.component.html',
  styleUrls: ['./patient.details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientDetailsComponent implements OnInit {
  @ViewChild('PatientDetailsForm', {static: false}) patientDetailsForm: WebFormLightContainerComponent;
  @Output() next = new EventEmitter();
  @Output() back = new EventEmitter();

  public patientDetailsURL: string;
  public patientDataValidated = false;
  public showForm = false;
  public continueClicked = false;
  // private nextFlag = false;
  // private backFlag = false;

  public informationText1 = '';
  public informationText2 = '';
  public informationText3 = '';
  public informationActionTextIndex = 0;
  public informationAction: any;

  constructor(private changeDetector: ChangeDetectorRef,
              private cfg:PreLoginSystemConfigurationValues,
              private appConfigService: AppConfigurationService) {
  }

  ngOnInit() {
    this.cfg.GetPatientDetailsForm().subscribe(form=>{
      this.patientDetailsURL = this.appConfigService.Config.webForms.patientDetailsURL;
      this.patientDetailsURL = this.patientDetailsURL.replace("@FORM_NAME@",form);
      this.showForm=true;
      this.changeDetector.markForCheck();
    })
    this.informationText1 = 'HaveYouBeenHereBefore';
    this.informationText2 = 'GoBack';
    this.informationText3 = 'ToSearchAgainOrContactUS';
    this.informationActionTextIndex = 2;
    this.informationAction = this.goback;
  }

  public continue() {
    if (this.patientDetailsForm){
      if (!this.continueClicked) {
        this.continueClicked = true;
        this.changeDetector.markForCheck();
        this.next.emit(this.patientDetailsForm.patient);
      }
    }else{
      this.retryAction(()=>this.continue());
    }
  }

  public goback() {
    if (this.patientDetailsForm){
      this.back.emit(this.patientDetailsForm.patient);
    } else {
      this.retryAction(() => this.goback());
    }
  }

  public setPatient(patient: any) {
    this.continueClicked = false;
    this.changeDetector.markForCheck();
    if (this.patientDetailsForm){
      this.patientDetailsForm.setData(patient,false);
    }else{
      this.retryAction(()=>this.setPatient(patient));
    }
  }

  public reset() {
    this.showForm = false;
    this.continueClicked = false;
    this.changeDetector.markForCheck();
    setTimeout(() => {
      this.showForm = true;
      this.changeDetector.markForCheck();
    }, 10);
  }

  public dataValidated(valid: boolean) {
    this.patientDataValidated = valid;
    this.changeDetector.markForCheck();
  }

  private retryAction(a: () => void) {
    setTimeout(() => {
      a();
    }, 50);
  }
}
